<template>
  <div>
    <wc-data-box
      v-if='project.project_detail'
      title='Lot Size Category'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      showEdit
      @edit='changeRating'
      :loading='isLoading'
    >
      <v-card-text class='text-center'>
        <h1 v-if='ratingDisplay.description.length' class='display-1 font-weight-light info--text'>{{ ratingDisplay.rating | dec }}</h1>
        <h1 v-else class='display-1 font-weight-light info--text'>Not Set</h1>
        <h2 class='mt-2'>{{ ratingDisplay.description }}</h2>
      </v-card-text>
      <wc-ratings :selected='project.project_detail.rating' :ratings='ratings'></wc-ratings>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      title='Change Rating'
      :icon='icon'
      :iconColor='iconColor'
      width='300'
      @cancel='showDialog = false'
      @save='updateRating'
    >
      <v-select
        v-model='detailCopy.rating'
        label='Select a rating'
        :items='ratings'
        :item-text='getSelectionText'
        item-value='id'
      ></v-select>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import settingsAPI from '@/modules/settings/api/settings'

export default {
  name: 'lawn-rating',
  props: {
    project: {
      required: true
    },
  },
  data: () => ({
    isLoading: true,
    showDialog: false,
    pricingConsiderations: [],
    detailCopy: [],
    ratings: [],
    icon: 'mdi-home-outline',
    iconColor: 'brown'
  }),
  created () {
    this.getData()
  },
  computed: {
    ratingDisplay () {
      if (this.project.project_detail.rating && this.ratings.length) {
        return _.find(this.ratings, r => r.id === this.project.project_detail.rating)
      }
      return { rating: null, description: '' }
    }
  },
  methods: {
    changeRating () {
      this.detailCopy = _.cloneDeep(this.project.project_detail)
      this.showDialog = true
    },
    async getData () {
      this.isLoading = true
      this.ratings = await settingsAPI.getRatings()
      if (this.project.project_detail.pricing_considerations) {
        this.pricingConsiderations = _.split(this.project.project_detail.pricing_considerations, ',')
      }
      this.isLoading = false
    },
    async updateRating () {
      this.project.project_detail = this.detailCopy;
      this.$emit('update', this.project);
      this.showDialog = false;
    },
    getSelectionText(item) {
      return item.description + ' - ' + this.$options.filters.decMoney(item.base_price)
    }
  }
}
</script>